<template>
  <SplideSlide class="aspect-square">
    <slot />
  </SplideSlide>
</template>

<script lang="ts">
export default { name: 'ProductGalleryImage' }
</script>

<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'
</script>
